import React from "react";
import {
  Avatar,
  Divider,
  List,
  Button,
  Tooltip,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { BsTrash } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
// component
import placeholder from "../../../asset/img/avatar.png";
// redux
import { deleteBranch } from "../../../store/branch/branch.action";

const BranchListing = (props) => {
  // -------------------------- VAR --------------------------
  const { data, owner } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION --------------------------
  const handleDelete = (item) => {
    dispatch(
      deleteBranch({ data: item }, (response) => {
        if (response.status === 200) {
          message.success("Successfully deleted branch");
        } else {
          message.error(response?.data);
        }
      })
    );
  };
  // -------------------------- RENDER --------------------------
  const renderItem = (item) => {
    const logo = item?.logo || placeholder;
    const code = item?.code;
    const createAt = item?.createAt;
    const createTime =
      createAt &&
      createAt.seconds &&
      moment(createAt.toDate()).format("ddd DD MMM YYYY hh:mm A");
    const title = (
      <span style={{ fontSize: 18 }}>
        {item?.name} | {item?.shopId} | <span className="code">{code}</span>{" "}
        <span className="time">Created On {createTime}</span>
      </span>
    );
    const description = <span>{item?.address}</span>;
    return (
      <List.Item
        key={item.id}
        actions={[renderEdit(item), renderDelete(item)]}
        style={{
          border: "1px solid #ccc",
          borderRadius: 5,
          marginTop: 10,
          padding: 20,
        }}
      >
        <List.Item.Meta
          avatar={renderAvatar(logo)}
          title={title}
          description={description}
        />
      </List.Item>
    );
  };

  const renderAvatar = (avatar) => {
    return <Avatar size={64} src={avatar} />;
  };

  const renderEdit = (item) => {
    return (
      <Tooltip title="Edit">
        <Button
          icon={
            <span className="anticon">
              <FiEdit2 />
            </span>
          }
          href={`/branchs/detail/${item?.id}/shop`}
        />
      </Tooltip>
    );
  };

  const renderDelete = (item) => {
    return (
      <Popconfirm
        title="Are you sure to delete this branch?"
        placement="leftTop"
        onConfirm={() => handleDelete(item)}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ danger: true }}
        icon={
          <span className="anticon">
            <BsTrash style={{ color: "red" }} />
          </span>
        }
      >
        <Tooltip title="Delete">
          <Button
            danger
            disabled={!owner}
            icon={
              <span className="anticon">
                <BsTrash />
              </span>
            }
          />
        </Tooltip>
      </Popconfirm>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <div id="scrollableDiv" style={{ overflow: "auto" }}>
      <InfiniteScroll
        dataLength={data?.length}
        hasMore={data?.length < 50}
        endMessage={<Divider plain>All data loaded</Divider>}
        scrollableTarget="scrollableDiv"
        style={{ marginTop: 20 }}
      >
        <List dataSource={data} renderItem={(item) => renderItem(item)} />
      </InfiniteScroll>
    </div>
  );
};

export default BranchListing;
